




































































import { requiredRule } from "@/lib/rules/requiredRule";
import {
  SignDigitalSignatureRequestSignerViewModelGen,
  SignDocumentTokenDtoGen
} from "@/services/sign/v1/data-contracts";
import { DocumentTemplateModule } from "@/store/modules/document-template.store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { isSignatureToken, isCrossToken } from "@/lib/signature-token.utils";
import { SignatureTokenEnum } from "@/lib/enum/signature-token.enum";
import SignFormEditorControls from "./SignFormEditorControls.vue";
import CustomFieldBoolean from "@/components/report/CustomFieldBoolean.vue";

@Component({
  components: { SignFormEditorControls, CustomFieldBoolean }
})
export default class SignFormEditorInputList extends Vue {
  readonly SignatureTokenEnum = SignatureTokenEnum;

  @Prop()
  currentPageNumber!: number;

  @Prop()
  signRequest!: SignDigitalSignatureRequestSignerViewModelGen;

  @Prop({ default: true })
  highlightToken?: boolean;

  get highlightedToken() {
    return DocumentTemplateModule.highlightedToken;
  }

  set highlightedToken(index: number) {
    DocumentTemplateModule.setHighlightedToken(index);
  }

  get editableDocumentTokens() {
    return DocumentTemplateModule.documentTokens.map(page => page.filter(t => t.isEditable));
  }

  @Watch("currentPageNumber")
  onPageChange() {
    document.getElementById(`page${this.currentPageNumber}`)?.scrollIntoView({ behavior: "smooth" });
  }

  openPage(pageNumber: number) {
    this.$emit("setCurrentPage", pageNumber);
  }

  getIsSignature(token: string) {
    return isSignatureToken(token);
  }

  getIsCrossToken(token: string) {
    return isCrossToken(token);
  }

  updateCrossToken(documentToken: SignDocumentTokenDtoGen) {
    documentToken.value = documentToken.value !== SignatureTokenEnum.CROSS_TOKEN ? SignatureTokenEnum.CROSS_TOKEN : "";
  }

  getRule(document: SignDocumentTokenDtoGen) {
    if (document.isRequired) {
      return [requiredRule(document.description)];
    }
    return [];
  }

  getInputRefForIndex(pageIndex: number, index: number) {
    return `input${pageIndex}${index}`;
  }

  getIndex(pageIndex: number, token: SignDocumentTokenDtoGen) {
    return DocumentTemplateModule.documentTokens[pageIndex].findIndex(
      t =>
        t.coordinates.h === token.coordinates.h &&
        t.coordinates.w === token.coordinates.w &&
        t.coordinates.x === token.coordinates.x &&
        t.coordinates.y === token.coordinates.y &&
        t.coordinates.fontSize === token.coordinates.fontSize &&
        t.token === token.token
    );
  }

  onFieldFocus(pageIndex: number, token: SignDocumentTokenDtoGen) {
    // Navigate to the page if it's different from current
    if (pageIndex !== this.currentPageNumber) {
      this.openPage(pageIndex);
    }

    if (!this.highlightToken) {
      return;
    }
    const index = this.getIndex(pageIndex, token);
    if (this.highlightedToken !== index) {
      this.highlightedToken = index;
    }
  }

  onFieldBlur() {
    if (!this.highlightToken) {
      return;
    }

    setTimeout(() => {
      this.highlightedToken = -1;
    }, 100);
  }

  @Watch("highlightedToken")
  updateHighlight() {
    if (!this.highlightToken) {
      return;
    }
    this.$nextTick(() => {
      setTimeout(() => {
        const ref = this.$refs[this.getInputRefForIndex(this.currentPageNumber, this.highlightedToken)];
        if (ref) {
          ref[0]?.focus();
        }
      });
    });
  }
}
